export const UPDATE_ADMIN_APP_DATA = 'UPDATE_ADMIN_APP_DATA';
export const ADD_SETUP_TO_LIST = 'ADD_SETUP_TO_LIST';
export const ADD_AWARDING_RULE_TO_LIST = 'ADD_AWARDING_RULE_TO_LIST';
